import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AmountStatus, Competitor, ConfirmPayment, RegistrationStatus} from "@model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AbstractComponent, BadgeColor} from "@components";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-accept-competitor-registration',
  templateUrl: './accept-competitor-registration.component.html',
  styleUrl: './accept-competitor-registration.component.scss'
})
export class AcceptCompetitorRegistrationComponent extends AbstractComponent implements OnInit {
    @Input() competitor: Competitor | undefined;
    @Output() onSave = new EventEmitter<ConfirmPayment | undefined>();
    registrationStatuses = [RegistrationStatus.RESERVED_FOR_PAYMENT, RegistrationStatus.CONFIRMED]
    items = [AmountStatus.NOT_PAID, AmountStatus.EXACT, AmountStatus.OVERPAID, AmountStatus.UNDERPAID];
    itemBadgeClasses : BadgeColor[] = ['red', 'green', 'blue', 'orange']
    inputForm = new FormGroup({
        registrationStatus: new FormControl(),
        amountStatus: new FormControl(),
        note: new FormControl(),
    });

    constructor(public activeModal: NgbActiveModal) {
      super();
    }

    ngOnInit(): void {
        this.inputForm.controls.note.setValue(this.competitor?.fee)
        this.inputForm.controls.registrationStatus.valueChanges.subscribe(val => {
            const isReserved =
                val === RegistrationStatus.RESERVED_FOR_PAYMENT ||
                val === RegistrationStatus.RESERVED_FOR_MANDATORY_PAYMENT;

            this.items = isReserved
                ? [AmountStatus.NOT_PAID, AmountStatus.UNDERPAID]
                : [AmountStatus.EXACT, AmountStatus.OVERPAID];
            this.itemBadgeClasses = isReserved
                ? ['red', 'orange']
                : ['green', 'blue'];

            const competitorAmountStatus = this.competitor?.registration?.amountStatus;

            const status = isReserved ?
                ((competitorAmountStatus === AmountStatus.NOT_PAID || competitorAmountStatus === AmountStatus.UNDERPAID) ? competitorAmountStatus : AmountStatus.NOT_PAID)
                :
                ((competitorAmountStatus === AmountStatus.EXACT || competitorAmountStatus === AmountStatus.OVERPAID) ? competitorAmountStatus : AmountStatus.EXACT)

            this.inputForm.controls.amountStatus.setValue(status);
        });

        this.inputForm.controls.registrationStatus.setValue(
            this.competitor?.registration?.id
                ? (this.competitor.registration.registrationStatus ?? RegistrationStatus.RESERVED_FOR_PAYMENT)
                : RegistrationStatus.RESERVED_FOR_PAYMENT
        );

    }

    onConfirmClick(): void {
      const confirmPayment = new ConfirmPayment(this.competitor?.registrationId,
          this.competitor?.id,
          this.inputForm.controls.amountStatus.value,
          this.inputForm.controls.registrationStatus.value,
          this.inputForm.controls.note.value);
      this.onSave.emit(confirmPayment);
      this.activeModal?.dismiss();
    }

    onDismissClick(): void {
      this.activeModal.dismiss();
    }


    protected readonly AmountStatus = AmountStatus;

}
